import axios from "../../api/axiosAuth";
import {tokenStorage} from "../../app/tokenStorage";
import {signoutUser} from "../../store/auth";
import {store} from "../../store";
import {LOGOUT} from "../../api/routes/auth_routes";

export default async function Logout() {
   try {
       await axios(LOGOUT, {
           withCredentials: true,
           headers: {
               "Access-Control-Allow-Origin": "*",
               "Authorization": `Bearer ${tokenStorage.getToken()}`,
               "Session-unique": `${tokenStorage.getSessionId()}`
           }
       });
   } catch (error) {
       console.error('Error:', error.message);
   }

    tokenStorage.clear();
    store.dispatch(signoutUser());
}
